export default "__VITE_ASSET__Cda6cngF__"